import React, { useMemo } from 'react';
import { getRemasteredImageUrl, getPixelatedImageUrl } from '../../utils/helpers';
import { LazyComponent } from '../../utils/LazyComponent';
import ThumbnailPlaceholder from '../../utils/ThumbnailPlaceholder';
import { Link } from 'react-router-dom';

export default function ThingThumbnail({ imageIndex, linkState }) {
  const src = useMemo(() => {
    return Math.random() < 0.5
      ? getRemasteredImageUrl(imageIndex)
      : getPixelatedImageUrl(imageIndex);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imageIndex]);

  return (
    <LazyComponent
      fallback={<ThumbnailPlaceholder />}
      rootMargin="100px"
    >
      <Link to={`/things/${imageIndex}`} state={linkState}>
        <ThumbnailPlaceholder />
        <img
          src={src}
          alt={`Thingdom ${imageIndex}`}
          loading="lazy"
        />
      </Link>
    </LazyComponent>
  );
};
